<template>
<div class="form-control" :class="formClass">
<v-form @submit.prevent>
    <ControlList v-if="value" :value="value" :schema="schemaFields" :context="childContext" @change="emitChanges"/>
</v-form>
</div>
</template>

<script>

export default {

    data() {
        return {
       
        }
    },

    components: {
        
    },
    
    props: {
        schema: Object,
        value: Object,
        context: Object,
    },

    computed: {
        formClass() {
            return {
                xray: this.schema.debug,
            }
        },

        childContext() {
            const ctx = JSON.parse(JSON.stringify(this.context || {}))
            ctx.form = JSON.parse(JSON.stringify(this.value))
            return ctx
        },

        schemaFields() {
            const fields = this.schema.fields
            fields.forEach(field => {
                field._root = this.schema
            })
            return fields
        }

    },

    methods: {
        focusFirst() {
            setTimeout(() => {
                const inputs = this.$el.getElementsByTagName('input')
                inputs[0].focus()
                inputs[0].select() 
            }, 300);
        },
        emitChanges(newVal) {
            this.$emit('input', newVal)
            this.$emit('change', newVal)
            console.log('Form emitted input and change', newVal)
        }
    },
    watch:{

    },
    created() {

    },
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// FormControl.vue?550f7031